import player_img from "../../../../../../../../../assets/games/Truco/profile.svg"


/**
 * PlayerInfo
 *
 * isMirrored — when the parent Seat has been scaleX(-1) mirrored, we apply
 * scaleX(-1) here too so that text and icons render the right way around again.
 */
export function PlayerInfo({ name, seatIndex, x, y, isMirrored = false, remaining, duration, showTimer }) {
  // Counter-mirror text content so it stays readable when the seat is flipped
  const counterMirror = isMirrored ? { transform: "scaleX(-1)" } : undefined
  const percentage = Math.max(
    0,
    Math.min(100, (remaining / duration) * 100)
  )
  const style = {
    ...(isMirrored && {
      right: 0,
      left: "unset",
      transform: "translate(50%,-50%)"
    }),
    ...(showTimer && {
      "--value": percentage
    })
  }

  return (
    <div className="truco-seat-player-details" style={{ top: y, left: x }}>
      <div className="truco-player-info" style={name ? { padding: isMirrored ? "10px 50px" : "10px 10px 10px 50px" } : {}}>
        <div className="truco-playerIcon" role={showTimer ? "progressbar" : "figure"} style={style}>
          <img src={player_img} className="" draggable="false" />
        </div>
        {name && (
          <span
            className="truco-playerName"
            style={seatIndex === 0 ? { top: 0, bottom: "auto" } : {}}
          >
            {name}
          </span>
        )}
      </div>

    </div >
  )
}